__turbopack_context__.v({
  "className": "manrope_667d5856-module__1t7LHG__className",
  "variable": "manrope_667d5856-module__1t7LHG__variable",
});
